let cityList = [
  {
    name: '北京市',
    code: 110000,
    data: require('../../static/json/beijing.json'),
  },
  {
    name: '天津市',
    code: 120000,
    data:  require('../../static/json/tianjin.json'),
  },
  {
    name: '河北省',
    code: 130000,
    data: require('../../static/json/hebei.json'),
  },
  {
    name: '山西省',
    code: 140000,
    data: require('../../static/json/shanxi.json'),
  },
  {
    name: '内蒙古自治区',
    code: 150000,
    data: require('../../static/json/neimenggu.json'),
  },
  {
    name: '辽宁省',
    code: 210000,
    data: require('../../static/json/liaoning.json'),
  },
  {
    name: '吉林省',
    code: 220000,
    data: require('../../static/json/jilin.json'),
  },
  {
    name: '黑龙江省',
    code: 230000,
    data: require('../../static/json/heilongjiang.json'),
  },
  {
    name: '上海市',
    code: 310000,
    data: require('../../static/json/shanghai.json'),
  },
  {
    name: '江苏省',
    code: 320000,
    data: require('../../static/json/jiangsu.json'),
  },
  {
    name: '浙江省',
    code: 330000,
    data: require('../../static/json/zhejiang.json'),
  },
  {
    name: '安徽省',
    code: 340000,
    data: require('../../static/json/anhui.json'),
  },
  {
    name: '福建省',
    code: 350000,
    data: require('../../static/json/fujian.json'),
  },
  {
    name: '江西省',
    code: 360000,
    data: require('../../static/json/jiangxi.json'),
  },
  {
    name: '山东省',
    code: 370000,
    data: require('../../static/json/shandong.json'),
  },
  {
    name: '河南省',
    code: 410000,
    data: require('../../static/json/henan.json'),
  },
  {
    name: '湖北省',
    code: 420000,
    data: require('../../static/json/hubei.json'),
  },
  {
    name: '湖南省',
    code: 430000,
    data: require('../../static/json/hunan.json'),
  },
  {
    name: '广东省',
    code: 440000,
    data: require('../../static/json/guangdong.json'),
  },
  {
    name: '广西壮族自治区',
    code: 450000,
    data: require('../../static/json/guangxi.json'),
  },
  {
    name: '海南省',
    code: 460000,
    data: require('../../static/json/hainan.json'),
  },
  {
    name: '重庆市',
    code: 500000,
    data: require('../../static/json/chongqing.json'),
  },
  {
    name: '四川省',
    code: 510000,
    data: require('../../static/json/sichuan.json'),
  },
  {
    name: '贵州省',
    code: 520000,
    data: require('../../static/json/guizhou.json'),
  },
  {
    name: '云南省',
    code: 530000,
    data: require('../../static/json/yunnan.json'),
  },
  {
    name: '西藏自治区',
    code: 540000,
    data: require('../../static/json/xizhang.json'),
  },
  {
    name: '陕西省',
    code: 610000,
    data: require('../../static/json/shangxi.json'),
  },
  {
    name: '甘肃省',
    code: 620000,
    data: require('../../static/json/gansu.json'),
  },
  {
    name: '青海省',
    code: 630000,
    data: require('../../static/json/qinghai.json'),
  },
  {
    name: '宁夏回族自治区',
    code: 640000,
    data: require('../../static/json/ningxia.json'),
  },
  {
    name: '新疆维吾尔自治区',
    code: 650000,
    data: require('../../static/json/xinjiang.json'),
  },
  {
    name: '香港特别行政区',
    code: 810000,
    data: require('../../static/json/xianggang.json'),
  },
  {
    name: '澳门特别行政区',
    code: 820000,
    data: require('../../static/json/aomen.json'),
  },
  {
    name: '台湾省',
    code: 710000,
    data: require('../../static/json/taiwan.json'),
  },
];
let china = require('../../static/json/china.json');
let chenzhou = require('../../static/json/chenzhou.json');
let guangzhou = require('../../static/json/guangzhou.json');
let shandong = require('../../static/json/shandong.json');

export default {
  cityList: cityList,
  china: china,
  chenzhou: chenzhou,
  guangzhou: guangzhou,
  shandong: shandong,

};




// WEBPACK FOOTER //
// ./src/components/cityExport.js